import { normalizeSearchTab } from './searchConstants';

export function buildSearchUrl({ q = '', tab = 'all' } = {}) {
  const params = new URLSearchParams();
  const query = String(q || '').trim();
  const normalizedTab = normalizeSearchTab(tab);
  if (query) params.set('q', query);
  if (normalizedTab && normalizedTab !== 'all') params.set('tab', normalizedTab);
  const qs = params.toString();
  return qs ? `/search?${qs}` : '/search';
}

export function navigateToSearch(navigate, { q = '', tab = 'all' } = {}) {
  navigate(buildSearchUrl({ q, tab }));
}
